import React from 'react';
import { NCZIEntrySection } from '../../../../Interfaces/ncziTypes';
import EHREntry from './EHREntry';
import NZCIListItem from '../../../Base/NZCIListItem';

interface Props {
	section: NCZIEntrySection | undefined;
}

const EHREntrySection: React.FC<Props> = props => {
	const { section } = props;

	if (!section) {
		return <></>;
	}

	return (
		<div style={{ marginBottom: '20px', marginLeft: '20px' }}>
			<NZCIListItem
				title={'nzci.name'}
				value={section.name}
				// extra={section.archetypeId}
			/>
			{section.entries.map((entry, key) => (
				<EHREntry item={entry} key={key} />
			))}
		</div>
	);
};

export default EHREntrySection;
